module.exports = __webpack_public_path__ + "static/media/project3.a3d72ccd.png";